var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Gadget } from '../libs/gadgets.class';
var Row = /** @class */ (function (_super) {
    __extends(Row, _super);
    function Row() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._ga = [];
        return _this;
    }
    Row.prototype.addCustomGadget = function (gadget, size) {
        this._ga.push([gadget, size]);
    };
    Row.prototype.render = function (forceParseGadgets) {
        var items = "";
        this._ga.forEach(function (e) {
            if (typeof e[0] === 'string') {
                items += "<div class=\"".concat(e[1], "\">").concat(e[0], "</div>");
            }
            else {
                items += "<div class=\"".concat(e[1], "\">").concat(e[0].render(), "</div>");
            }
        });
        return "<div class=\"row\">".concat(items, "</div>");
    };
    return Row;
}(Gadget));
export { Row };
